import React from "react";
import { useReveal } from "@/lib/useReveal";

const Reveal = ({ children, delay = 0, as: Tag = "div", className = "", ...rest }) => {
  const [ref] = useReveal({ threshold: 0.12 });
  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`reveal ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
